import { Injectable } from '@angular/core';
import { CustomHttp, ApiConstants } from '../../shared';

@Injectable()
export class QAService {

    constructor(private http: CustomHttp, private apiConstants: ApiConstants) {}

    public createQARequest(parrotId: string, user: string, type: 'mappings' | 'images') {
        const uri = this.apiConstants.ENDPOINT_QA_REQUESTS +
        `/create?parrot_id=${parrotId}&requesting_user=${user}&type=${type}`;

        return this.http.post(uri, {});
    }

    public getQARequests(state: 'incomplete' | 'complete', type?: 'mappings' | 'images',
        orderBy?: 'created_on' | 'updated_on', page: number = 0, size: number = 50)
    {
        const uri = this.apiConstants.ENDPOINT_QA_REQUESTS +
        `?state=${state}${type ? `&type=${type}` : ''}${orderBy ? `&orderBy=${orderBy}` : ''}` +
        `${page ? `&page=${page}` : ''}${size ? `&size=${size}` : ''}`;

        return this.http.get(uri);
    }

    public getLastPendingQARequest(parrotId: string, type: string) {
        const uri = this.apiConstants.ENDPOINT_QA_REQUESTS +
        `/pending?parrot_id=${parrotId}&type=${type}`;

        return this.http.get(uri);
    }

    public getLastCompletedQARequest(parrotId: string, type: string, contentType) {
        const uri = this.apiConstants.ENDPOINT_QA_REQUESTS +
        `/complete?parrot_id=${parrotId}&type=${type}&contentType=${contentType}`;

        return this.http.get(uri);
    }

    public updateQARequest(parrotId: string, user: string, type: 'mappings' | 'images') {
        const uri = this.apiConstants.ENDPOINT_QA_REQUESTS +
        `/update?parrot_id=${parrotId}&completing_user=${user}&type=${type}`;

        return this.http.post(uri, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/qa/qa.service.ts